// extracted by mini-css-extract-plugin
export var errorsContainer = "_v1-1";
export var link = "_v1-0";